import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  evt_id: string().required(),
});

/**
 * SystemHeartbeatEvent
 *
 * - Esse vai ser enviado pelo servidor caso o cliente não enviar o evento ClientHeartbeat a cada 30 segundos. O cliente deve responder com o evento ClientHeartbeat em no máximo 5s.
 */
export class SystemHeartbeatEvent extends CreateCommand(RealtimeEventType.SystemHeartbeat, SCHEMA) {}
